import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ImageCoordinates } from '../../../../state-management/model/interfaces/screen-size.model';
import { CoordinatesSystem, ImageFormat, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { EditableButtonComponent } from '../../../base/button/editable-button/editable-button.component';
import { EditableTextComponent } from '../../../base/text/editable-text/editable-text.component';
import { EditableImageComponent } from '../../../base/image/editable-image/editable-image.component';
import { FileType } from '../../../../state-management/model/enums/state.enums';

@Component({
    selector: 'app-base-single-column-text-image',
    imports: [
        EditableImageComponent,
        EditableTextComponent,
        EditableButtonComponent
    ],
    templateUrl: './base-single-column-text-image.component.html',
    styleUrl: './base-single-column-text-image.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseSingleColumnTextImageComponent extends BaseComponent {
  public supportedFileTypes = [FileType.WEBP, FileType.JPEG];

  override labelMap = {
    contactButton: 'contactButton',
    text: 'text',
    image: 'image'
  };

  override imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.ScreenWidth,
    formatMap: {
      [ScreenWidthBreakpoints.XSmall]: ImageFormat.FourToThree,
      [ScreenWidthBreakpoints.Small]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.Medium]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.Large]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.XLarge]: ImageFormat.SixteenToNine,
    }
  };
}